import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Tracker partner configuration schema
 *
 * Note: Tracker agents do not require configuration fields.
 * The integration is set up at the backend level and does not need
 * customer-provided configuration values (config is null).
 */
export const trackerSchema: PartnerSchemaInternal = {
  partner: 'tracker' as PartnerEnum,
  displayName: 'Tracker',
  fields: [], // No configuration fields - backend handles setup
}
